module.exports = __webpack_public_path__ + "img/ella.8d79bdfb.svg";